'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useSearchParams } from 'next/navigation';
import { ReviewDetailSessionPortal } from '@/app/donation/_components/ReviewDetailSessionPortal';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { PhotoReviewsModalContent } from '../gifts/[productNumber]/_components/PhotoReviewsModalContent';
interface PhotoReviewSwiperProps {
  photoReviewList: {
    fileUrl: string;
    reviewId: number;
  }[];
  photoReviewCount: number;
  productNumber?: string;
  institutionId?: number;
  className?: string;
}
export const PhotoReviewSwiper = t0 => {
  const $ = _c(47);
  const {
    photoReviewList,
    photoReviewCount,
    productNumber,
    institutionId,
    className
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("detailReviewId");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const detailReviewIdParam = t1;
  const detailReviewId = detailReviewIdParam ? Number(detailReviewIdParam) : undefined;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [emblaRef] = useEmblaCarousel(t2);
  let t3;
  if ($[3] !== institutionId || $[4] !== photoReviewCount || $[5] !== photoReviewList || $[6] !== productNumber) {
    t3 = reviewId => {
      openResponsiveDialog({
        component: PhotoReviewsModalContent,
        modalHeader: "\uD3EC\uD1A0\uD6C4\uAE30",
        className: {
          modal: "max-w-[900px]"
        },
        props: {
          productNumber,
          institutionId,
          photoReviewList,
          photoReviewCount,
          initialReviewId: reviewId
        },
        drawerNoPadding: true
      });
    };
    $[3] = institutionId;
    $[4] = photoReviewCount;
    $[5] = photoReviewList;
    $[6] = productNumber;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleDetailReviewId = t3;
  if (photoReviewCount < 1) {
    return null;
  }
  let t4;
  if ($[8] !== className) {
    t4 = cn("flex flex-col pb-24", className);
    $[8] = className;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("flex items-center justify-between py-12", "mobile-tablet:py-16");
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== photoReviewCount) {
    t6 = photoReviewCount.toLocaleString();
    $[11] = photoReviewCount;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <h2 className="font-700 text-Gray-900 typo-body2">포토후기 {t6}</h2>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== institutionId || $[16] !== photoReviewCount || $[17] !== photoReviewList || $[18] !== productNumber) {
    t8 = () => openResponsiveDialog({
      component: PhotoReviewsModalContent,
      modalHeader: "\uD3EC\uD1A0\uD6C4\uAE30 \uC804\uCCB4\uBCF4\uAE30",
      className: {
        modal: "max-w-[900px]"
      },
      props: {
        institutionId,
        productNumber,
        photoReviewList,
        photoReviewCount
      }
    });
    $[15] = institutionId;
    $[16] = photoReviewCount;
    $[17] = photoReviewList;
    $[18] = productNumber;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SvgChevronright className="size-12" />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8) {
    t10 = <Button theme="sub-text" className="flex size-fit items-center gap-4 px-4 py-10 font-400 text-Gray-900 typo-body4" onClick={t8}>더보기{t9}</Button>;
    $[21] = t8;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t7) {
    t11 = <div className={t5}>{t7}{t10}</div>;
    $[23] = t10;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== handleDetailReviewId || $[27] !== photoReviewList) {
    let t13;
    if ($[29] !== handleDetailReviewId) {
      t13 = t14 => {
        const {
          fileUrl,
          reviewId: reviewId_0
        } = t14;
        return <div key={reviewId_0} className="w-fit flex-[0_0_auto]"><button type="button" className={cn("relative size-104 overflow-hidden rounded-small border border-Gray-black/5 transition-opacity duration-200", "hover:opacity-80", "active:opacity-80", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500")} onClick={() => handleDetailReviewId(reviewId_0)}><Image src={fileUrl} alt={"\uD3EC\uD1A0\uD6C4\uAE30 \uC774\uBBF8\uC9C0"} width={850} height={850} className="size-full object-cover object-center" /></button></div>;
      };
      $[29] = handleDetailReviewId;
      $[30] = t13;
    } else {
      t13 = $[30];
    }
    t12 = photoReviewList.map(t13);
    $[26] = handleDetailReviewId;
    $[27] = photoReviewList;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[31] !== t12) {
    t13 = <div className="flex gap-8">{t12}</div>;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== emblaRef || $[34] !== t13) {
    t14 = <div className="w-full overflow-hidden" ref={emblaRef}>{t13}</div>;
    $[33] = emblaRef;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  const t15 = !isDesktopViewport && !!detailReviewId;
  let t16;
  if ($[36] !== handleDetailReviewId) {
    t16 = () => handleDetailReviewId(undefined);
    $[36] = handleDetailReviewId;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== detailReviewId || $[39] !== t15 || $[40] !== t16) {
    t17 = <ReviewDetailSessionPortal open={t15} onClose={t16} reviewId={detailReviewId} />;
    $[38] = detailReviewId;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t11 || $[43] !== t14 || $[44] !== t17 || $[45] !== t4) {
    t18 = <section className={t4}>{t11}{t14}{t17}</section>;
    $[42] = t11;
    $[43] = t14;
    $[44] = t17;
    $[45] = t4;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  return t18;
};